<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>CIE10</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              placeholder="Seleccione..."
              @input="inputPadre"
              id="padre_id"
              :options="cie10"
              label="nombre"
              v-model="selectedPadre"
            ></v-select>
            <label for="padre_id">Cie10 principal</label>
            <span v-if="errores.padre_id" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.padre_id[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field id="codigo" placeholder="Código" v-model="form.codigo">
            <span>Código</span>
            <span v-if="errores.codigo" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.codigo[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field id="descripcion" placeholder="Descripción" v-model="form.descripcion">
            <span>Descripción</span>
            <span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.descripcion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="guardar" class="btn-success" type="button">
        <i class="fa fa-save"></i>
        <span>Guardar</span>
      </button>
      <button @click="$emit('cancelar')" class="btn-danger btn--text" type="button">
        <i class="fa fa-ban"></i>
        <span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    editando: function() {
      return this.form.estado !== "N";
    }
  },
  data: function() {
    return {
      form: JSON.parse(JSON.stringify(this.value)),
      errores: {},
      cie10: [],
      selectedPadre: null
    };
  },
  mounted: function() {
    this.cargarCie10();
  },
  methods: {
    inputPadre: function() {
      if (this.selectedPadre !== null)
        this.form.padre_id = this.selectedPadre.id;
      else this.form.padre_id = "";
    },
    cargarCie10: function() {
      axios.get(url + "/listado-cie10").then(({ data }) => {
        this.cie10 = data;
        for (let i = 0; i < this.cie10.length; i++)
          if (this.cie10[i].id == this.form.padre_id) {
            this.selectedPadre = this.cie10[i];
            break;
          }
      });
    },
    guardar: function() {
      let that = this;
      let urlRequest = url + "/cie10";
      if (this.editando) {
        urlRequest += "/" + this.form.id;
        that.form._method = "PUT";
      } else that.form._method = undefined;
      axios
        .post(urlRequest, this.form)
        .then(function(response) {
          swal("El cie10 fue almacenado.", "Realizado", "success");
          that.$emit("saved", response.data);
        })
        .catch(function(error) {
          if (error && error.response) {
            let response = error.response;
            let status = response.status;
            switch (status) {
              case 422:
                that.errores = response.data.errors;
                swal("Hay errores en el formulario.", "Aviso", "warning");
                return;
            }
          }
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    cancelar: function() {
      this.$emit("cancelar");
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/cie10/Cie10.vue